import { API } from '@Providers';

export default async function (payload: string) {
  const endpoint = `/api/shelter/cart/get-outcome-details-desktop/${payload}`;

  return API({ endpoint });
}
